import { AxiosError, AxiosResponse } from 'axios'
import useSWR, { SWRConfiguration } from 'swr'
import useSWRMutation, { SWRMutationConfiguration } from 'swr/mutation'

import {
    GetMeCardsResponseEntity, GetMeProfilesResponseEntity, PostMeCardsRequestEntity,
    PostMeCardsResponseEntity
} from '../entities/me'
import app from './app'

export default {
    profiles: {
        useFetchSWR: (config?: SWRConfiguration) => useSWR('/me/profiles', url => app({ authorized: 'required' }).get<GetMeProfilesResponseEntity>(url).then(r => r.data), config),
    },

    cards: {
        useFetchSWR: (config?: SWRConfiguration) => useSWR('/me/cards', url => app({ authorized: 'required' }).get<GetMeCardsResponseEntity>(url).then(r => r.data), config),

        useInsertSWR: (config?: SWRMutationConfiguration<AxiosResponse<PostMeCardsResponseEntity, PostMeCardsRequestEntity>, AxiosError>) => useSWRMutation('/me/cards', (url: string, { arg }: { arg: PostMeCardsRequestEntity }) => app({ authorized: 'required' }).post<PostMeCardsResponseEntity>(url, arg), config),

        useRejectSWR: (cardId?: string, config?: SWRMutationConfiguration<AxiosResponse<void, void>, AxiosError>) => useSWRMutation(cardId ? `/me/cards/${cardId}` : null, (url: string) => app({ authorized: 'required' }).delete(url), config),
    }
}